import { useState, useEffect } from 'react';

export default function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    // const ROUND_START_DATE = new Date('2024-12-12T17:00:00Z');
    // const ROUND_DURATION = 14 * 24 * 60 * 60 * 1000;

    // const calculateNextRound = () => {
    //   const now = new Date();
    //   const elapsed = now.getTime() - ROUND_START_DATE.getTime();
    //   const roundsPassed = Math.max(0, Math.floor(elapsed / ROUND_DURATION));
    //   const nextRound = new Date(ROUND_START_DATE.getTime() + (roundsPassed + 1) * ROUND_DURATION);
    //   return nextRound;
    // };

    const TARGET_DATE = new Date(import.meta.env.VITE_TARGET_DATE || '2025-04-23T17:00:00Z');

    const timer = setInterval(() => {
      // const nextRound = calculateNextRound();
      const now = new Date().getTime();
      const distance = TARGET_DATE.getTime() - now;
      // const distance = nextRound.getTime() - now;

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000)
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="grid grid-cols-4 gap-4 text-center">
      {Object.entries(timeLeft).map(([unit, value]) => (
        <div key={unit} className="bg-white rounded-lg p-4 shadow-lg">
          <div className="text-4xl font-bold text-primary">
            {String(value).padStart(2, '0')}
          </div>
          <div className="text-gray-600 capitalize">{unit}</div>
        </div>
      ))}
    </div>
  );
}